import React from 'react';
import { Eye, FileCheck, Clock, ShieldCheck, Briefcase, BadgeCheck } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';

const iconMap = {
  eye: Eye,
  'file-check': FileCheck,
  clock: Clock,
  'shield-check': ShieldCheck,
  briefcase: Briefcase,
  'badge-check': BadgeCheck
};

export const WhyChooseUs = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
            Why Choose Us
          </h2>
          <p className="text-lg text-gray-600">Committed to excellence in every engagement</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div key={item.id} className="flex items-start space-x-4 p-6 rounded-lg bg-white hover:bg-blue-50 transition-all duration-300 border border-transparent hover:border-teal-500 shadow-sm hover:shadow-md">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-teal-50 rounded-lg flex items-center justify-center">
                    <IconComponent className="text-teal-600" size={24} />
                  </div>
                </div>
                <div>
                  <h4 className="text-gray-800 font-semibold text-lg">{item.title}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};